import {
  TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44,
  TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54,
  TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64,
  TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER,
  TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35,
} from './constants';
import { TargetScoreRangeAgeGroup } from '../../../TargetScore';

export function getTtBreakpointsFromAgeGroup(ageGroup: TargetScoreRangeAgeGroup) {
  switch (ageGroup) {
    case 'Under35':
      return TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35;
    case '35To44':
      return TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44;
    case '45To54':
      return TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54;
    case '55To64':
      return TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64;
    case '65AndOver':
      return TOTAL_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER;
    default:
      return [];
  }
}
